import { makeAutoObservable } from 'mobx';

export interface IVenueRemark {
  remark001: string | null;
  remark002: string | null;
  entry001: string | null;
  entry002: string | null;
  parking001: string | null;
  parking002: string | null;
  garbage001: string | null;
  garbage002: string | null;
  entry003: string | null;
  entry004: string | null;
  parking003: string | null;
}

export class VenueRemarkModel implements IVenueRemark {
  remark001: string | null;
  remark002: string | null;
  entry001: string | null;
  entry002: string | null;
  entry003: string | null;
  entry004: string | null;
  parking001: string | null;
  parking002: string | null;
  parking003: string | null;
  garbage001: string | null;
  garbage002: string | null;
  [key: string]: string | null;

  constructor(res?: IVenueRemark) {
    makeAutoObservable(this);
    this.remark001 = res?.remark001 ?? null;
    this.remark002 = res?.remark002 ?? null;
    this.entry001 = res?.entry001 ?? 'ENTRY_O_004';
    this.entry002 = res?.entry002 ?? null;
    this.entry003 = res?.entry003 ?? null;
    this.entry004 = res?.entry004 ?? null;
    this.parking001 = res?.parking001 ?? 'PARKING_O_009';
    this.parking002 = res?.parking002 ?? null;
    this.parking003 = res?.parking003 ?? null;
    this.garbage001 = res?.garbage001 ?? null;
    this.garbage002 = res?.garbage002 ?? null;
  }
}
